<!-- src/lib/components/migration/SourcePicker.svelte -->
<!-- Step 1: Pick the data source to migrate from -->
<script lang="ts">
  import type { MigrationSource } from '../../types.ts';

  interface Props {
    onSelect: (source: MigrationSource) => void;
    onBack: () => void;
  }
  let { onSelect, onBack }: Props = $props();

  const sources: { id: MigrationSource; label: string; icon: string; description: string }[] = [
    { id: 'linear',  label: 'Linear',  icon: '◈', description: 'Issues, cycles, projects, members' },
    { id: 'plane',   label: 'Plane',   icon: '◉', description: 'Issues, modules, cycles, labels' },
    { id: 'asana',   label: 'Asana',   icon: '⬡', description: 'Tasks, projects, sections, members' },
    { id: 'figma',   label: 'Figma',   icon: '◻', description: 'Files, frames, comments, components' },
  ];
</script>

<div class="step">
  <h2 class="step-title">Choose your data source</h2>
  <p class="step-hint">Select the tool you want to import from.</p>

  <div class="source-grid">
    {#each sources as src}
      <button class="source-card" onclick={() => onSelect(src.id)}>
        <span class="source-icon" aria-hidden="true">{src.icon}</span>
        <span class="source-label">{src.label}</span>
        <span class="source-desc">{src.description}</span>
      </button>
    {/each}
  </div>

  <div class="actions">
    <button class="btn-secondary" onclick={onBack}>Cancel</button>
  </div>
</div>

<style>
.step { display: flex; flex-direction: column; gap: 1rem; }
.step-title { margin: 0; font-size: 1.05rem; font-weight: 600; color: var(--text-primary); }
.step-hint { margin: 0; font-size: 0.82rem; color: var(--text-muted); }

.source-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.75rem;
  margin-top: 0.5rem;
}

.source-card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.4rem;
  padding: 1rem 1.125rem;
  background: rgba(255,255,255,0.03);
  border: 1px solid rgba(255,255,255,0.08);
  border-radius: 8px;
  cursor: pointer;
  transition: background 120ms ease, border-color 120ms ease;
  text-align: left;
}
.source-card:hover {
  background: rgba(255,255,255,0.07);
  border-color: var(--ab-purple-core);
}

.source-icon { font-size: 1.4rem; color: var(--ab-purple-bright); line-height: 1; }
.source-label { font-size: 0.9rem; font-weight: 600; color: var(--text-primary); }
.source-desc { font-size: 0.74rem; color: var(--text-muted); }

.actions { display: flex; justify-content: flex-start; margin-top: 0.25rem; }

.btn-secondary {
  background: rgba(255,255,255,0.03);
  border: 1px solid rgba(255,255,255,0.08);
  color: var(--text-muted);
  padding: 0.4rem 0.875rem;
  border-radius: 5px;
  cursor: pointer;
  font-size: 0.82rem;
  transition: background 120ms ease;
}
.btn-secondary:hover { background: rgba(255,255,255,0.07); }
</style>
